/* Auto Pjesë Bajrami — fjalori i Bacit.
   I ndarë nga theme.js me qëllim: fjalët e pjesëve ndryshojnë shpesh (shtojmë
   një produkt të ri, mësojmë një fjalë të re që e shkruajnë klientët), kurse
   logjika e leximit nuk ndryshon. Kështu një fjalë e re është një skedar 3 KB,
   jo i gjithë theme.js. Nëse ky skedar mungon, Baci ende punon — thjesht nuk
   i njeh fjalët e pjesëve dhe e lëshon fjalinë ashtu siç është. */
window.BAJRAMI_WORDS = {
  /* Pjesët e karrocerisë: kërkohen bashkë me modelin dhe gjeneratën. */
  parts: [
    ['parakolp para', 'front bumper'], ['parakolp mbrapa', 'rear bumper'],
    ['parakolp', 'bumper'], ['branik', 'bumper'],
    ['body kit', 'body kit'], ['bodikit', 'body kit'], ['bodykit', 'body kit'],
    ['difuzor', 'diffuser'], ['diffuser', 'diffuser'],
    ['spoiler', 'spoiler'], ['spojler', 'spoiler'],
    ['grill', 'grill'], ['maska', 'grill'], ['maske', 'grill'],
    ['front lip', 'front lip'], ['lip', 'lip'], ['splitter', 'splitter'],
    ['prag', 'side skirt'], ['side step', 'side steps'],
    ['blatnik', 'fender'], ['fender', 'fender'],
    ['kapak', 'hood'], ['hood', 'hood'], ['hauba', 'hood'],
    ['dritat', 'lights'], ['drita', 'lights'], ['fener', 'headlight'],
    ['far', 'headlight'], ['stopa', 'taillight'],
    ['auspuh', 'exhaust'], ['marmit', 'exhaust'], ['exhaust', 'exhaust'],
    ['tepih', 'floor mats'], ['pasqyr', 'mirror'], ['aero', 'aero kit'],
    ['conversion', 'conversion'], ['konvertim', 'conversion']
  ],

  /* Gjëra që i shesim por që nuk lidhen me modelin e veturës: bateri, llamba,
     kimikate, mirëmbajtje. Titujt e tyre s'e kanë modelin, prandaj kërkimi bëhet
     vetëm me fjalën e produktit — përndryshe "bateri per Audi A6" kthen zero. */
  universal: [
    ['bateri', 'battery'], ['akumulator', 'battery'], ['battery', 'battery'],
    ['vaj motori', 'engine oil'], ['engine oil', 'engine oil'], ['motor oil', 'engine oil'],
    ['pastrues fren', 'brake cleaner'], ['brake cleaner', 'brake cleaner'],
    ['pastrues xham', 'glass cleaner'], ['glass cleaner', 'glass cleaner'],
    ['pastrues kokpit', 'dashboard cleaner'], ['kokpit', 'dashboard'], ['dashboard', 'dashboard'],
    ['shkelqim gom', 'tire shine'], ['luster gom', 'tire shine'], ['tire shine', 'tire shine'],
    ['freskues', 'air freshener'], ['air freshener', 'air freshener'], ['odorizues', 'air freshener'],
    ['shampon', 'shampoo'], ['shampo', 'shampoo'], ['shampoo', 'shampoo'],
    ['sfungjer', 'sponge'], ['sponge', 'sponge'],
    ['mikrofiber', 'microfiber'], ['microfiber', 'microfiber'],
    ['dyll', 'wax'], ['vaks', 'wax'],
    ['polir', 'polish'], ['polish', 'polish'],
    ['llamb', 'bulb'], ['sijalic', 'bulb'], ['bulb', 'bulb'],
    ['lekur', 'leather'], ['leather', 'leather'],
    ['filter grimc', 'particulate filter cleaner']
  ],

  /* Gjëra që NUK i shesim. Kur klienti e emërton njërën, s'guxojmë ta heqim
     fjalën dhe t'ia shfaqim parakolpat e veturës së tij — do të lexohej si "po".
     E themi hapur çka nuk kemi, dhe pastaj i tregojmë çka kemi. */
  notOurs: [
    ['pllakat e fren', 'Pllakat e frenave'], ['ferrota', 'Ferrotat'],
    ['disqe fren', 'Disqet e frenave'], ['disqet e fren', 'Disqet e frenave'],
    ['brake pad', 'Pllakat e frenave'], ['brake disc', 'Disqet e frenave'],
    ['gom', 'Gomat'], ['tyre', 'Gomat'],
    ['amortiz', 'Amortizatorët'], ['shock absorber', 'Amortizatorët'],
    ['kupllung', 'Kupllungu'], ['kuplung', 'Kupllungu'], ['clutch', 'Kupllungu'],
    ['kambio', 'Kambio'], ['gearbox', 'Kambio'], ['transmision', 'Transmisioni'],
    ['alternator', 'Alternatori'], ['altenator', 'Alternatori'],
    ['anlaser', 'Anlaseri'], ['starter', 'Anlaseri'],
    ['radiator', 'Radiatori'], ['hladnjak', 'Radiatori'],
    ['kandel', 'Kandelat'], ['spark plug', 'Kandelat'],
    ['injektor', 'Injektorët'], ['injector', 'Injektorët'],
    ['turbo', 'Turbo'],
    ['timing belt', 'Rripi i motorit'], ['rripi i motorit', 'Rripi i motorit'],
    ['pompa e uji', 'Pompa e ujit'], ['pompa e naft', 'Pompa e naftës'],
    ['kompresor', 'Kompresori i klimës'],
    ['motor komplet', 'Motori'], ['engine block', 'Motori'],
    ['parbriz', 'Xhami i përparmë'], ['windshield', 'Xhami i përparmë'],
    ['ulese', 'Ulëset'], ['sedilje', 'Ulëset'], ['seat cover', 'Këllëfët e ulëseve']
  ],

  /* Rregulla që pastrojnë shkrimin para se të fillojë leximi.
     [modeli i regex-it, flamujt, zëvendësimi] — zbatohen me radhë.
     Këtu hyjnë prapashtesat shqipe dhe gabimet e shpeshta të shtypit. */
  rules: [
    /* "1she", "3-shi", "x5shi", "golf 7-shi" — prapashtesa shqipe te numri.
       Kërkohet shifër para "sh", që fjalë si "marshi" të mos preken. */
    ["([0-9])[-\\s]?sh[ie]($|[^a-z0-9])", "g", "$1$2"],
    /* "bww", "bmv", "bemve" — si e shkruajnë BMW-në kur nxitojnë. */
    ["(^|[^a-z0-9])(bww|bmv|bemve|bimer)($|[^a-z0-9])", "g", "$1bmw$3"],
    /* "golfi", "golfin", "passati", "tiguani" — nyja shquese te modeli. */
    ["(^|[^a-z0-9])(golf|passat|tiguan|polo|touareg|arteon)(i|in|it|un|ut)($|[^a-z0-9])", "g", "$1$2$4"],
    /* "perpara" e ka "para" brenda, por "prapa" jo — ndaj e qartësojmë. */
    ["(^|[^a-z0-9])perpara($|[^a-z0-9])", "g", "$1para$2"]
  ],

  /* Si e shkruajnë njerëzit vërtet. Majtas ajo që shkruajnë, djathtas ajo që
     e njeh katalogu. Zëvendësohet me një kalim të vetëm, para se të lexohet. */
  alias: [
    ['mk7.5','golf 7.5'], ['mk 7.5','golf 7.5'], ['mk7','golf 7'], ['mk 7','golf 7'],
    ['mk8','golf 8'], ['mk 8','golf 8'], ['mk6','golf 6'], ['mk5','golf 5'],
    ['merqedes','mercedes'], ['mercedez','mercedes'], ['mercedesz','mercedes'],
    ['c-klase','c-class'], ['c klase','c-class'], ['seri c','c-class'], ['c klas','c-class'],
    ['e-klase','e-class'], ['e klase','e-class'], ['seri e','e-class'], ['e klas','e-class'],
    ['s-klase','s-class'], ['s klase','s-class'], ['a-klase','a-class'], ['a klase','a-class'],
    ['g-klase','g-class'], ['g klase','g-class'],
    ['gle','gle-class'], ['glc','glc-class'], ['gla','gla-class'], ['glb','glb-class'],
    ['gls','gls-class'], ['cla','cla-class'], ['cls','cls-class'], ['cle','cle-class'],
    ['seria 1','1 series'], ['seri 1','1 series'], ['seria 2','2 series'], ['seri 2','2 series'],
    ['seria 3','3 series'], ['seri 3','3 series'], ['seria 4','4 series'], ['seri 4','4 series'],
    ['seria 5','5 series'], ['seri 5','5 series'], ['seria 6','6 series'], ['seri 6','6 series'],
    ['seria 7','7 series'], ['seri 7','7 series'], ['seria 8','8 series'], ['seri 8','8 series'],
    ['series 3','3 series'], ['series 5','5 series'], ['series 1','1 series']
  ]
};